module.exports = __webpack_public_path__ + "img/800_cd.939c0ee1.jpg";